'use strict';

(function ($) {
  Drupal.behaviors.product = {
    attach: function (context) {
      $('.path-product .button .primary-button').each(function () {
        $(this).bind('click', function () {
          $('.horizontal-tab-button-0 a').trigger('click');
        });
      });

      $('.horizontal-tab-button-2').bind('click', function (e) {
        window.open($('.file--application-pdf').find('a').attr('href'), '_blank');
        e.stopImmediatePropagation();
      });
    }
  }
})(jQuery);
